import { render, staticRenderFns } from "./ModulesDrawer.vue?vue&type=template&id=29edbe2c"
import script from "./ModulesDrawer.vue?vue&type=script&lang=js"
export * from "./ModulesDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports